module.exports = __webpack_public_path__ + "img/Weapon_125.68dddb57.png";